import { render, staticRenderFns } from "./BannerX.vue?vue&type=template&id=d1201436"
import script from "./BannerX.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerX.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BannerX.vue?vue&type=style&index=0&id=d1201436&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports